import { useEffect, useRef } from 'react';
import styles from './EventPagination.module.css';

type Props = {
    hasMore: boolean;
    loading: boolean;
    error: string | null;
    hasEvents: boolean;
    loadMore: () => void;
};

export default function EventPagination({ hasMore, loading, error, hasEvents, loadMore }: Props) {
    const sentinel = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!hasMore || loading || error || !sentinel.current || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) loadMore();
        }, { rootMargin: '600px 0px' });
        observer.observe(sentinel.current);
        return () => observer.disconnect();
    }, [hasMore, loading, error, loadMore]);

    return <div ref={sentinel} className={styles.pagination} aria-busy={loading}>
        <p role="status" aria-live="polite">
            {loading ? 'Chargement des événements…' : error || (
                !hasMore && hasEvents ? 'Tous les événements de cette période sont affichés.' : ''
            )}
        </p>
        {(hasMore || error) && <button type="button" onClick={loadMore} disabled={loading}>
            {error ? 'Réessayer' : 'Afficher plus d’événements'}
        </button>}
    </div>;
}
